import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, UserIcon } from 'lucide-react';
const buyers = [{
  name: 'Patrizia C.',
  city: 'Milano'
}, {
  name: 'Giuseppe M.',
  city: 'Roma'
}, {
  name: 'Antonella G.',
  city: 'Napoli'
}, {
  name: 'Roberto V.',
  city: 'Torino'
}, {
  name: 'Sabrina R.',
  city: 'Bologna'
}, {
  name: 'Marco L.',
  city: 'Firenze'
}, {
  name: 'Chiara B.',
  city: 'Palermo'
}, {
  name: 'Francesca F.',
  city: 'Genova'
}, {
  name: 'Luca D.',
  city: 'Bari'
}, {
  name: 'Elena T.',
  city: 'Verona'
}, {
  name: 'Stefano A.',
  city: 'Catania'
}, {
  name: 'Maria P.',
  city: 'Padova'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 4000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-262">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: 50,
      y: -10
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: 50,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 280,
      damping: 26
    }} className="fixed top-4 right-3 sm:top-6 sm:right-6 z-50 max-w-[280px] w-[calc(100%-1.5rem)]" data-id="element-263">
          <div className="bg-[#0f0f1a] border border-white/15 rounded-xl p-3 shadow-[0_8px_30px_rgba(0,0,0,0.6)] relative overflow-hidden" data-id="element-264">
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-brand-orange via-brand-gold to-brand-orange" data-id="element-265" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" aria-label="Chiudi" data-id="element-266">
              <XIcon className="w-3.5 h-3.5" data-id="element-267" />
            </button>

            <div className="flex items-center gap-2 pr-5 mb-1.5" data-id="element-268">
              <div className="w-8 h-8 rounded-full bg-white/10 border border-white/20 flex items-center justify-center shrink-0" data-id="element-269">
                <UserIcon className="w-4 h-4 text-gray-300" data-id="element-270" />
              </div>
              <div className="flex items-center gap-1.5 flex-wrap min-w-0" data-id="element-271">
                <span className="font-black text-brand-cream text-[13px]" data-id="element-272">
                  {currentBuyer.name}
                </span>
                <span className="text-gray-400 text-[12px]" data-id="element-273">
                  da {currentBuyer.city}
                </span>
                <img src="https://flagcdn.com/w40/it.png" alt="IT" className="w-4 h-3 rounded-sm object-cover" data-id="element-274" />
              </div>
            </div>

            <p className="text-[12px] text-gray-200 font-medium leading-snug pl-10 mb-2" data-id="element-275">
              Ha appena acquistato{' '}
              <span className="font-black text-brand-orange" data-id="element-276">
                Metodo Economia Aziendale Pro
              </span>{' '}
              📊
            </p>

            <div className="flex items-center gap-1.5 pl-10 pt-1 border-t border-white/10" data-id="element-277">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse shrink-0" data-id="element-278" />
              <span className="text-[10px] font-black uppercase tracking-wider text-green-400" data-id="element-279">
                Acquisto Verificato
              </span>
              <span className="text-[10px] text-gray-500" data-id="element-280">·</span>
              <span className="text-[10px] font-bold uppercase tracking-wider text-gray-400" data-id="element-281">
                {timeAgo} min fa
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}